import React, { useState } from 'react';
import Documentation from '../../asset/Documentation.png'
import CallManagement from '../../asset/CallManagement.png'
import Prestigious from '../../asset/Prestigious.png'
import Demand from '../../asset/Demand.png'

export const KeyBenifits = () => {
    const [hoveredCard, setHoveredCard] = useState(null)

    const userTypes = [
        {
            id: 'Prestigious',
            title: 'Prestigious Chennai Business Address',
            description: "Make your mark in Chennai's commercial hub",
            image: Prestigious,
            position: 'top',
        },
        {
            id: 'Demand',
            title: 'On-Demand Meeting Rooms',
            description: 'Access premium meeting rooms by the hour for client meetings or interviews. Wi-Fi, AV support, and hospitality included..',
            image: Demand,
            position: 'bottom',
        },
        {
            id: 'CallManagement',
            title: 'Call Answering & Mail Management',
            description: 'We answer calls in your company name and handle courier/document deliveries with real-time alerts.',
            image: CallManagement,
            position: 'top',
        },
        {
            id: 'Docimentation',
            title: 'Compliance-Ready Documentation ',
            description: 'Make a lasting impression with a central business district address. Use it for GST registration, ROC filings, invoices, and building client trust.',
            image: Documentation,
            position: 'bottom',
        },
    ]

    const renderCard = ({ id, title, description, image }) => (
        <div
            key={id}
            style={{ borderRadius: '20px', background: '#FFF4F8' }}
            className={`flex flex-col cursor-pointer justify-center CollaborativeCatagory p-3 sm:p-4 items-center w-[200px] sm:w-[250px] h-[200px] sm:h-[250px] bg-[#FFF4F8] transition-all duration-300 ease-in-out`}
            onMouseEnter={() => setHoveredCard(id)}
            onMouseLeave={() => setHoveredCard(null)}
        >
            {/* Image and Title container */}
            <div className={`flex flex-col items-center transition-opacity duration-300 ease-in-out ${hoveredCard === id ? 'opacity-0 h-0 overflow-hidden' : 'opacity-100'}`}>
                <img className='w-[60px] sm:w-[80px] pb-3 sm:pb-4' src={image} alt={title} />
                <p className='text-lg sm:text-xl md:text-2xl font-regrade font-semibold text-center'>
                    {title}
                </p>
            </div>

            {/* Description */}
            <p
                className={`text-center text-[#6D7E94] pt-2 text-sm transition-all duration-300 ease-in-out ${hoveredCard === id ? 'opacity-100 max-h-[100px]' : 'opacity-0 max-h-0 overflow-hidden'}`}
            >
                {description}
            </p>
        </div>
    );


    return (
        <section className="py-8 sm:py-12 px-4 sm:px-6 bg-white">
            <div className="max-w-[75rem] mx-auto">
                <h2 className="text-[#966376] font-sans text-base sm:text-lg font-[600] font-semibold uppercase text-center">Key Benefits</h2>
                <h3 className="text-[#0B2549] font-regrade text-2xl sm:text-3xl md:text-5xl font-bold leading-tight mt-3 mx-auto text-center px-4">
                    Everything You Need to Work Smarter

                </h3>

                <div className="w-full mt-20 lg:w-auto flex flex-col items-center">
                    <div className='flex flex-col sm:flex-row gap-4 sm:gap-8 justify-center'>
                        {userTypes.map(renderCard)}
                    </div>
                </div>
            </div>
        </section>
    );
};
